import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/monthly-budget',
  component: () => import('../../routes/MonthlyBudget.svelte'),
  card: {
    id: 'monthly-budget',
    title: 'Monthly Budget Planner',
    description: 'Track income, expenses, and savings using the 50/30/20 rule with personalized insights.',
    icon: 'pie_chart',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/monthly-budget',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Monthly Budget Calculator – 50/30/20 Budget Planner',
    description: 'Free monthly budget calculator using the 50/30/20 rule. Track income, expenses, and savings with personalized insights. Plan your budget effectively with our budget planner tool.',
  },
};

export default meta;
